const selector = 'form[data-scroll-to-error]';

const scrolledForms = new WeakSet();

export const initializeScrollToError = root => {
    const forms = root.matches?.(selector) ? [root] : root.querySelectorAll(selector);

    forms.forEach(form => {
        if (scrolledForms.has(form)) {
            return;
        }

        scrolledForms.add(form);

        form.querySelector('.invalid-feedback, [data-scroll-target]').scrollIntoView({behavior: 'smooth', block: 'center'});
    });
};
